// ============================================================================
// Verified company, founder, contact & proof data — single source of truth.
// All values here were confirmed by the founder (Roshan Hegde). Do not invent
// or alter these. Photo is a real professional photograph supplied by Roshan
// (never AI-generated / modified).
// ============================================================================

export const FOUNDER = {
  name: "Roshan Hegde",
  titleWorkPay: "Founder, WorkPay",
  titleOther: "Founder, 36Hours",
  location: "Dubai, United Arab Emirates",
  linkedin: "https://www.linkedin.com/in/roshan-hegde-8b277311b/",
  photo: "/founder-roshan.png",
  story: [
    "WorkPay was created by Roshan Hegde, founder of 36Hours, after experiencing first-hand how delayed payments, unclear approvals and milestone disputes affect project-based businesses.",
    "While operating a UAE printing, signage and branding business, Roshan saw that vendors needed a professional way to begin work with payment clarity—and customers needed a transparent way to see project terms, track milestones and approve progress.",
    "WorkPay is now opening a founder-led private launch for selected UAE service businesses.",
  ],
};

export const CONTACT = {
  email: "support@workpay-app.com",
  phone: "+971 55 223 9345",
  phoneHref: "tel:+971552239345",
  whatsapp: "https://wa.me/971552239345",
  location: "Dubai, United Arab Emirates",
  responseTime: "within 1–2 business days",
};

export const STORES = {
  googlePlay: "https://play.google.com/store/apps/details?id=app.workpay.com",
  appStore: "https://apps.apple.com/us/app/workpay-app/id6761526663",
};

// Legal operator — verified registration details.
export const LEGAL_OPERATOR = {
  sentence:
    "WorkPay is a software product operated by Furroo FZE LLC, a company registered in the United Arab Emirates.",
  name: "Furroo FZE LLC",
  freeZone: "SPC Free Zone, Sharjah, United Arab Emirates",
  license: "4307730.01",
  trn: "104143405900003",
};

// Private-testing proof — verified from real UAE project-payment testing.
export const PROOF = {
  hasNumbers: true,
  amount: "AED 43,000+",
  payments: "20+",
  window: "in the first 3 days of private testing",
  updated: "June 2026",
  qualification:
    "Private-testing figures may include transactions involving the founder's related operating business, 36Hours. Independent-customer traction is tracked separately.",
};

// Honest 36Hours statement (approved wording).
export const STORY_36HOURS =
  "WorkPay was shaped by payment and approval challenges experienced while operating 36Hours, a UAE project-based printing, signage and branding business.";
